const swiperMultimediaList = {
    swiperInstances: [],

    init: () => {
        import('swiper/bundle').then(({ Swiper }) => {
            let domEls = jQuery('.js-swiper-multimedia-list');

            if (domEls.length) {
                domEls.each((index, el) => {
                    const swiperInstance = new Swiper(el, getSwiperParams());
                    swiperMultimediaList.swiperInstances.push(swiperInstance);

                    const domElsPagination = jQuery(el).parent().next().find('.js-swiper-multimedia-list-pagination');
                    const domElsPaginationLinks = domElsPagination.find('button[rel]');

                    swiperInstance.on('activeIndexChange', function() {
                        setTxtPaginationActiveItem(swiperInstance.realIndex)
                        pauseVideo();
                    });

                    const pauseVideo = () => {
                        jQuery(".plyr__video-wrapper iframe").each(function() {
                            this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                        });
                    }

                    domElsPaginationLinks.each((index, link) => {
                        jQuery(link).on("click", function() {
                            const slideIndex = parseInt(jQuery(this).attr('rel'));
                            swiperInstance.slideTo(slideIndex);
                        });
                    });

                    const setTxtPaginationActiveItem = (slideIndex) => {
                        domElsPaginationLinks.each((index, el) => {
                            const slideIndexRel = parseInt(jQuery(el).attr('rel'));
                            jQuery(el).removeClass("is-active");

                            if (slideIndexRel === slideIndex) {
                                jQuery(el).addClass("is-active");
                            }
                        });
                    }
                });
            }
        });
    }
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 500,
        effect: 'fade',
        resizeObserver: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        a11y: true,
        allowTouchMove: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    };
};

export default swiperMultimediaList;